import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'
// import config from '@/config'
// import axios from 'axios'

export const GET_MONTOS_COTIZACIONES = gql`
  query GET_MONTOS_COTIZACIONES {
    montos_cotizaciones: dashboard_resumen_cotizaciones_y_montos {
      id
      statistic_number_1
      statistic_number_2
      subTitle_1
      subTitle_2
      title_1
      title_2
      language
    }
  }
`

export const createNewMontosCotizaciones = gql`
  mutation createNewMontosCotizaciones(
    $title_2: String!
    $title_1: String!
    $subTitle_2: String!
    $subTitle_1: String!
    $statistic_number_2: String!
    $statistic_number_1: String!
    $language: String!
  ) {
    insert_dashboard_resumen_cotizaciones_y_montos(
      objects: {
        language: $language
        statistic_number_1: $statistic_number_1
        statistic_number_2: $statistic_number_2
        subTitle_1: $subTitle_1
        subTitle_2: $subTitle_2
        title_1: $title_1
        title_2: $title_2
      }
    ) {
      returning {
        id
      }
    }
  }
`
export const updateMontosCotizaciones = gql`
  mutation updateMontosCotizaciones(
    $language: String!
    $statistic_number_1: String!
    $statistic_number_2: String!
    $subTitle_1: String!
    $subTitle_2: String!
    $title_1: String!
    $title_2: String!
    $id: Int!
  ) {
    update_dashboard_resumen_cotizaciones_y_montos_by_pk(
      pk_columns: { id: $id }
      _set: {
        language: $language
        statistic_number_1: $statistic_number_1
        statistic_number_2: $statistic_number_2
        subTitle_1: $subTitle_1
        subTitle_2: $subTitle_2
        title_1: $title_1
        title_2: $title_2
      }
    ) {
      id
    }
  }
`

export const deleteRegistro = gql`
  mutation DeleteRegistro($id: Int!) {
    delete_dashboard_resumen_cotizaciones_y_montos_by_pk(id: $id) {
      id
    }
  }
`

const montosCotizaciones = {
  namespaced: true,
  state: {
    montosCotizaciones: [],
    availableLanguages: [
      {
        value: 'es',
        text: 'Español'
      },
      {
        value: 'en',
        text: 'Inglés'
      }
    ]
  },
  actions: {
    async fetchAll ({ state, commit }) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: GET_MONTOS_COTIZACIONES
        }
        const response = await apolloClient.query(requestQuery)
        if (response && response.data) {
          Vue.set(state, 'montosCotizaciones', response.data.montos_cotizaciones)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async createNewMontosCotizaciones ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: createNewMontosCotizaciones,
          variables
        })
        if (response && response.data && response.data.insert_dashboard_resumen_cotizaciones_y_montos) {
          dispatch('fetchAll')
          return response.data.insert_dashboard_resumen_cotizaciones_y_montos.returning[0]
        }
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async updateMontosCotizaciones ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: updateMontosCotizaciones,
          variables
        })
        if (response && response.data && response.data.update_dashboard_resumen_cotizaciones_y_montos_by_pk) {
          dispatch('fetchAll')
          return response.data.update_dashboard_resumen_cotizaciones_y_montos_by_pk
        }
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async deleteRegistro ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: deleteRegistro,
          variables
        })
        if (response && response.data && response.data.delete_dashboard_resumen_cotizaciones_y_montos_by_pk) {
          dispatch('fetchAll')
          return response.data.delete_dashboard_resumen_cotizaciones_y_montos_by_pk
        }
      } catch (error) {
        console.error(error)
        return error
      }
    }
  },
  mutations: {
  }
}

export default montosCotizaciones



// WEBPACK FOOTER //
// ./src/store/modules/montosCotizaciones.js